import { RedditStoriesForm } from '@/features/factory/subfactories/RedditStoriesForm'

export function RedditStoriesPage() {
  return <RedditStoriesForm />
}
